import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import { Link } from 'react-router-dom';
import styles from '../stylepacks.module.css';
import type { GraphicItem } from './video-list-graphic.types';

export default function VideoCard(video: GraphicItem) {
  return (
    <Container borderRadius="12px" width="auto" className={`overflow-hidden ${styles.card}`}>
      <img src={video.thumbnailUrl} className="width-auto max-width-100-percent" />
      <Container className={styles.cardOverlay} hoverBackground="rgba(var(--gray-1200-rgb), 0.4)">
        <Link to={`./preview/greenroom`} relative="path" state={{ videoId: video.id }}>
          <Button design="LocalBttnPrim" designSize="medium">
            Preview
          </Button>
        </Link>
      </Container>
    </Container>
  );
}
